var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasTiers
    ? _c(
        "div",
        [
          _c("label", { staticClass: "d-block mb-25" }, [
            _vm._v(_vm._s(_vm.$t("Faixas de taxa da loja"))),
          ]),
          _c("p", { staticClass: "text-muted mb-50 small" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    "A taxa cobrada é a faixa correspondente ao total de produtos (descontando grupos isentos)."
                  )
                ) +
                " "
            ),
          ]),
          _c(
            "b-table-simple",
            {
              staticClass: "mb-0 delivery-tiers-preview",
              attrs: { small: "", responsive: "" },
            },
            [
              _c(
                "b-thead",
                [
                  _c(
                    "b-tr",
                    [
                      _c("b-th", [
                        _vm._v(_vm._s(_vm.$t("Faixa (total de produtos)"))),
                      ]),
                      _c("b-th", { staticClass: "text-right" }, [
                        _vm._v(" " + _vm._s(_vm.$t("Taxa")) + " "),
                      ]),
                      _c("b-th"),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-tbody",
                _vm._l(_vm.orderedTiers, function (tier, index) {
                  return _c(
                    "b-tr",
                    {
                      key: index,
                      class: { "table-primary": index === _vm.activeIndex },
                    },
                    [
                      _c("b-td", [_vm._v(_vm._s(_vm.tierRangeLabel(index)))]),
                      _c("b-td", { staticClass: "text-right" }, [
                        Number(tier.value) === 0
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("Grátis")))])
                          : _c("span", [
                              _vm._v(_vm._s(_vm._f("currency")(tier.value))),
                            ]),
                      ]),
                      _c(
                        "b-td",
                        { staticClass: "text-right" },
                        [
                          index === _vm.activeIndex
                            ? _c("b-badge", { attrs: { variant: "primary" } }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Faixa atual")) + " "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }